<template lang="pug">
v-container.pa-8
  v-layout.pa-6(v-if="isFetching")
    v-row.fill-height.ma-0(align='center' justify='center')
      v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
  template(v-else)
    v-row
      v-col
        div.heading-5.basic700--text {{ this.company.name }}
        span.text-sm.font-medium.info500--text.clickable(@click="goToLink") {{ getPageLink() }}
      v-col.shrink
        div.d-flex
          v-btn.heading-7.pr-4.pl-3.text-none(color="basic700" small height="32" outlined style="border-radius: 8px;" @click="goToLink")
            eva-icon.mr-1.mb-n1(name="diagonal-arrow-right-up-outline" height="20" width="20" fill="var(--v-basic700)")
            | {{ $t('go_to_link') }}
          v-btn.heading-7.pr-4.pl-3.ml-2.text-none(color="basic700" small depressed dark height="32" style="border-radius: 8px;" @click="copyUrl" v-clipboard:copy="getPageLink()")
            eva-icon.mr-1.mb-n1(name="copy-outline" height="20" width="20" fill="white" )
            | {{ $t('copy_link') }}

    div.main-container.my-5
      v-row(no-gutters)
        v-col(cols="12" sm="8")
          v-tabs(v-model="manageTab" color="basic700" :height="44")
            v-tab.text-lg.font-medium.text-capitalize(v-if="Auth('component', '/admin/clinic/manage#general')") {{ $t('general') }}
            v-tab.text-lg.font-medium.text-capitalize(v-if="Auth('component', '/admin/clinic/manage#patient_form')") {{ $t('patient_form') }}
            v-tab.text-lg.font-medium.text-capitalize {{ $t('provider') }}
            v-tab.text-lg.font-medium.text-capitalize {{ $t('services') }}
            v-tab.text-lg.font-medium.text-capitalize(v-if="Auth('component', '/admin/clinic/manage#sharing')") {{ $t('sharing') }}
            
      v-divider

    v-tabs-items(v-model="manageTab" touchless)
      v-tab-item(v-if="Auth('component', '/admin/clinic/manage#general')") {{ $t('general') }}
        manage-general
      v-tab-item(v-if="Auth('component', '/admin/clinic/manage#patient_form')") {{ $t('patient_form') }}
        manage-patient-form
      v-tab-item
        manage-provider
      v-tab-item
        manage-services
      v-tab-item(v-if="Auth('component', '/admin/clinic/manage#sharing')") {{ $t('sharing') }}
        manage-sharing

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ManageGeneral from '@/components/clinic/manage/ManageGeneral.vue'
import ManageSharing from '@/components/clinic/manage/ManageSharing.vue'
import ManageProvider from '@/components/clinic/manage/ManageProvider.vue'
import ManageServices from '@/components/clinic/manage/ManageServices.vue'
import ManagePatientForm from '@/components/clinic/manage/ManagePatientForm.vue'

export default {
  name: 'ClinicPageSetup',
  components: { ManageGeneral, ManageSharing, ManageProvider, ManageServices, ManagePatientForm },
  props: ['fromTab'],
  data () {
    return {
      isFetching: false,
      manageTab: 0
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      form: 'clinic/getForm'
    }),
  },
  created () {
    this.fetchClinic()
  },
  mounted () {
    if (this.fromTab) {
      this.manageTab = this.fromTab
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchClinic () {
      this.isFetching = true
      this.$axios.get(`/clinics/${this.company.slug}?expand=form,company`)
        .then(resp => {
          this.$store.commit('clinic/setClinic', resp.data)
          this.$store.commit('clinic/setForm', resp.data.form)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    getPageLink () {
      return `https://${this.company.slug}.yezza.co/appointment`
    },
    copyUrl() {
      this.showMessage(['success', this.$t('success_message.link_copied_to_clipboard')])
    },
    goToLink () {
      window.open(this.getPageLink(), '_blank')
    }
  },
}
</script>

<style scoped>
.clickable {
  cursor: pointer;
}
.main-container {
  position: relative;
}
.separator {
  position: absolute;
  height:2px;
  top: 38px;
  left: 0px;
  right: 0px;
}
</style>